import { dbPromise } from "./db"

const SCHEDULE_ENTRIES_CACHE_KEY = "weekly_schedule_entries"

export async function saveScheduleEntriesCache(byDate) {
  if (!byDate) return
  const db = await dbPromise
  const pruned = pruneOldDates(byDate)
  await db.put("schedule_entries_cache", {
    key: SCHEDULE_ENTRIES_CACHE_KEY,
    byDate: pruned,
    savedAt: new Date().toISOString()
  })
}

export async function getScheduleEntriesCache() {
  const db = await dbPromise
  try {
    return (await db.get("schedule_entries_cache", SCHEDULE_ENTRIES_CACHE_KEY)) || null
  } catch {
    return null
  }
}

export async function getScheduleEntriesForDate(dateIso) {
  const record = await getScheduleEntriesCache()
  return record?.byDate?.[dateIso] || null
}

export async function getScheduleEntriesForWorker(dateIso, workerId) {
  const byWorker = await getScheduleEntriesForDate(dateIso)
  if (!byWorker) return []
  return byWorker[String(workerId)] || []
}

function pruneOldDates(byDate) {
  const today = todayIso()
  return Object.fromEntries(
    Object.entries(byDate).filter(([dateIso]) => dateIso >= today)
  )
}

function todayIso() {
  const d = new Date()
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, "0")
  const day = String(d.getDate()).padStart(2, "0")
  return `${y}-${m}-${day}`
}
